import { useState, useEffect } from "react";
import "./logo-loader.css";
import svgPaths from "./imports/svg-bs2zueahoj";

interface LogoLoaderProps {
  isLoading: boolean;
}

const LOGO_PARTS = [
  { id: "part-1", d: svgPaths.pb926300, fill: "#171F27" },
  { id: "part-2", d: svgPaths.p218a5600, fill: "#171F27" },
  { id: "part-3", d: svgPaths.p12a95b80, fill: "#171F27" },
  { id: "part-4", d: svgPaths.p5cec880, fill: "#027574" },
  { id: "part-5", d: svgPaths.p1a601680, fill: "#027574" },
];

const STAGGER_MS = 70;

export function LogoLoader({ isLoading }: LogoLoaderProps) {
  const [assembled, setAssembled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAssembled(true), 450);
    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="logo-overlay" role="status" aria-label="Loading">
      <div
        className={`logo-container logo-container-in ${
          assembled ? "logo-breathe" : ""
        }`}
        style={{
          width: 130,
          height: 130,
        }}
      >
        <svg viewBox="0 0 25.0457 29.1943" width="100" height="115">
          {LOGO_PARTS.map((part, i) => (
            <path
              key={part.id}
              d={part.d}
              fill={part.fill}
              className="logo-part"
              style={{
                animationDelay: `${i * STAGGER_MS}ms`,
              }}
            />
          ))}
        </svg>
      </div>

      <p className="logo-loading-text logo-loading-text-in mt-6">
        Loading
        <span className="logo-dot logo-dot-1">.</span>
        <span className="logo-dot logo-dot-2">.</span>
        <span className="logo-dot logo-dot-3">.</span>
      </p>
    </div>
  );
}

export default LogoLoader;
